import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";

export const FooterBar = () => {
  const { lang } = useSite();
  return (
    <footer data-testid="footer-bar" className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 flex flex-wrap items-center justify-between gap-4">
        <a href="/" className="flex items-center gap-2.5 font-display font-extrabold text-slate-900">
          <img src="/logo.png" alt="i.S.i Group" className="h-8 w-auto object-contain" />
          i.S.i Group
        </a>
        <p className="text-xs font-semibold text-slate-400">
          © {new Date().getFullYear()} i.S.i Group. {lang === "zh" ? "用心守护每个家。" : "Guarding every family with care."}
        </p>
      </div>
    </footer>
  );
};

export const SubpageShell = ({ children, titleZh, titleEn, withFooter = true }) => {
  const { lang, setLang, content, loading } = useSite();

  useEffect(() => {
    if (!titleZh) return;
    document.title = lang === "zh" ? `${titleZh} | i.S.i Group` : `${titleEn} | i.S.i Group`;
  }, [lang, titleZh, titleEn]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200/60">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
          <a href="/" data-testid="subpage-logo" className="flex items-center gap-2.5 font-display font-extrabold text-lg text-slate-900 whitespace-nowrap shrink-0">
            <img src="/logo.png" alt="i.S.i Group" className="h-9 w-auto object-contain" />
            i.S.i Group
          </a>
          <div className="flex items-center gap-3">
            <div data-testid="subpage-lang-toggle" className="flex items-center rounded-full bg-slate-100 p-1 border border-slate-200 shrink-0">
              {["zh", "en"].map((l) => (
                <button
                  key={l}
                  data-testid={`subpage-lang-${l}`}
                  onClick={() => setLang(l)}
                  className={`px-3 py-1 rounded-full text-xs font-bold transition-[background-color,color] duration-300 ${
                    lang === l ? "bg-orange-500 text-white shadow-sm" : "text-slate-500 hover:text-slate-800"
                  }`}
                >
                  {l === "zh" ? "中文" : "EN"}
                </button>
              ))}
            </div>
            <a
              data-testid="subpage-back-home"
              href="/"
              className="inline-flex items-center gap-1.5 rounded-full border-2 border-slate-900 px-3 sm:px-5 py-2 text-xs font-bold text-slate-900 hover:bg-slate-900 hover:text-white transition-[background-color,color] duration-300 whitespace-nowrap shrink-0"
            >
              <ArrowLeft size={14} />
              <span className="hidden min-[400px]:inline">{lang === "zh" ? "返回首页" : "Back to Home"}</span>
            </a>
          </div>
        </div>
      </header>
      <main className="flex-1">
        {loading || !content ? (
          <div className="min-h-[60vh] grid place-items-center">
            <div className="w-12 h-12 rounded-2xl bg-sky-400 animate-pulse" />
          </div>
        ) : (
          children
        )}
      </main>
      {withFooter && <FooterBar />}
      <FloatingWhatsApp />
    </div>
  );
};
